export const getBgColorOfRemainingQty = (
  remainingQty: number | undefined | null
) => {
  if (remainingQty === undefined || remainingQty === null) {
    return '#fff';
  }
  if (remainingQty === 0) {
    return '#20c997';
  } else if (remainingQty < 0) {
    return '#ff0000';
  } else if (remainingQty > 0) {
    return '#ffd43b';
  } else {
    return '#fff';
  }
};
